// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlay del modal de confirmación */
.confirm-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Contenedor del modal */
.confirm-dialog-content {
  position: relative;
  background: #1a1a1a;
  border: 1px solid #2d2d2d;
  border-radius: 16px;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.6),
              0 0 0 1px rgba(255, 255, 255, 0.05);
  animation: slideUp 0.3s ease-out;
  overflow: hidden;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Botón de cerrar */
.confirm-dialog-close {
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s;
  z-index: 1;
}

.confirm-dialog-close:hover:not(:disabled) {
  background: #2d2d2d;
  color: #ffffff;
}

.confirm-dialog-close:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Header del modal */
.confirm-dialog-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 32px 24px;
  text-align: center;
  border-bottom: 1px solid #2d2d2d;
}

/* Iconos según variante */
.dialog-icon {
  margin-bottom: 16px;
  padding: 16px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
}

.dialog-icon.danger {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

.dialog-icon.warning {
  color: #f59e0b;
  background: rgba(245, 158, 11, 0.1);
}

.dialog-icon.info {
  color: #3b82f6;
  background: rgba(59, 130, 246, 0.1);
}

/* Título */
.confirm-dialog-title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: -0.5px;
}

/* Body del modal */
.confirm-dialog-body {
  padding: 24px 32px;
}

.confirm-dialog-message {
  margin: 0;
  font-size: 15px;
  line-height: 1.6;
  color: #d1d5db;
  text-align: center;
}

/* Footer con botones */
.confirm-dialog-footer {
  display: flex;
  gap: 12px;
  padding: 24px 32px;
  border-top: 1px solid #2d2d2d;
  background: #141414;
}

/* Botones */
.confirm-dialog-btn {
  flex: 1 1;
  padding: 12px 24px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  overflow: hidden;
}

.confirm-dialog-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Botón cancelar */
.confirm-dialog-btn-cancel {
  background: #2d2d2d;
  color: #e5e7eb;
  border: 1px solid #3d3d3d;
}

.confirm-dialog-btn-cancel:hover:not(:disabled) {
  background: #3d3d3d;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

/* Botón confirmar - variante danger (rojo) */
.confirm-dialog-btn-confirm.danger {
  background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.2);
}

.confirm-dialog-btn-confirm.danger:hover:not(:disabled) {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(220, 38, 38, 0.4);
}

/* Botón confirmar - variante warning (amarillo/naranja) */
.confirm-dialog-btn-confirm.warning {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.2);
}

.confirm-dialog-btn-confirm.warning:hover:not(:disabled) {
  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.4);
}

/* Botón confirmar - variante info (azul) */
.confirm-dialog-btn-confirm.info {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
}

.confirm-dialog-btn-confirm.info:hover:not(:disabled) {
  background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
}

/* Animación de carga */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

.confirm-dialog-btn:disabled {
  animation: pulse 1.5s ease-in-out infinite;
}

/* Responsive */
@media (max-width: 640px) {
  .confirm-dialog-content {
    max-width: 100%;
    margin: 20px;
    border-radius: 12px;
  }

  .confirm-dialog-header {
    padding: 32px 24px 20px;
  }

  .dialog-icon {
    padding: 12px;
  }

  .confirm-dialog-title {
    font-size: 20px;
  }

  .confirm-dialog-body {
    padding: 20px 24px;
  }

  .confirm-dialog-message {
    font-size: 14px;
  }

  .confirm-dialog-footer {
    padding: 20px 24px;
    flex-direction: column-reverse;
  }

  .confirm-dialog-btn {
    width: 100%;
    padding: 14px 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ConfirmDialog.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB;iDAC+C;EAC/C,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA,WAAW;AACX;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,6CAA6C;AAC7C;EACE,6DAA6D;EAC7D,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,0DAA0D;AAC1D;EACE,6DAA6D;EAC7D,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,2CAA2C;AAC3C;EACE,6DAA6D;EAC7D,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,eAAe;AACf;EACE;IACE,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":["/* Overlay del modal de confirmación */\n.confirm-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.85);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  padding: 20px;\n  animation: fadeIn 0.2s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Contenedor del modal */\n.confirm-dialog-content {\n  position: relative;\n  background: #1a1a1a;\n  border: 1px solid #2d2d2d;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 480px;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.6),\n              0 0 0 1px rgba(255, 255, 255, 0.05);\n  animation: slideUp 0.3s ease-out;\n  overflow: hidden;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Botón de cerrar */\n.confirm-dialog-close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: transparent;\n  border: none;\n  border-radius: 8px;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: all 0.2s;\n  z-index: 1;\n}\n\n.confirm-dialog-close:hover:not(:disabled) {\n  background: #2d2d2d;\n  color: #ffffff;\n}\n\n.confirm-dialog-close:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Header del modal */\n.confirm-dialog-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 40px 32px 24px;\n  text-align: center;\n  border-bottom: 1px solid #2d2d2d;\n}\n\n/* Iconos según variante */\n.dialog-icon {\n  margin-bottom: 16px;\n  padding: 16px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.dialog-icon.danger {\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.1);\n}\n\n.dialog-icon.warning {\n  color: #f59e0b;\n  background: rgba(245, 158, 11, 0.1);\n}\n\n.dialog-icon.info {\n  color: #3b82f6;\n  background: rgba(59, 130, 246, 0.1);\n}\n\n/* Título */\n.confirm-dialog-title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: #ffffff;\n  letter-spacing: -0.5px;\n}\n\n/* Body del modal */\n.confirm-dialog-body {\n  padding: 24px 32px;\n}\n\n.confirm-dialog-message {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.6;\n  color: #d1d5db;\n  text-align: center;\n}\n\n/* Footer con botones */\n.confirm-dialog-footer {\n  display: flex;\n  gap: 12px;\n  padding: 24px 32px;\n  border-top: 1px solid #2d2d2d;\n  background: #141414;\n}\n\n/* Botones */\n.confirm-dialog-btn {\n  flex: 1;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 10px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  position: relative;\n  overflow: hidden;\n}\n\n.confirm-dialog-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Botón cancelar */\n.confirm-dialog-btn-cancel {\n  background: #2d2d2d;\n  color: #e5e7eb;\n  border: 1px solid #3d3d3d;\n}\n\n.confirm-dialog-btn-cancel:hover:not(:disabled) {\n  background: #3d3d3d;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n}\n\n/* Botón confirmar - variante danger (rojo) */\n.confirm-dialog-btn-confirm.danger {\n  background: linear-gradient(135deg, #dc2626 0%, #991b1b 100%);\n  color: #ffffff;\n  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.2);\n}\n\n.confirm-dialog-btn-confirm.danger:hover:not(:disabled) {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(220, 38, 38, 0.4);\n}\n\n/* Botón confirmar - variante warning (amarillo/naranja) */\n.confirm-dialog-btn-confirm.warning {\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: #ffffff;\n  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.2);\n}\n\n.confirm-dialog-btn-confirm.warning:hover:not(:disabled) {\n  background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.4);\n}\n\n/* Botón confirmar - variante info (azul) */\n.confirm-dialog-btn-confirm.info {\n  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n  color: #ffffff;\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);\n}\n\n.confirm-dialog-btn-confirm.info:hover:not(:disabled) {\n  background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);\n}\n\n/* Animación de carga */\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.6;\n  }\n}\n\n.confirm-dialog-btn:disabled {\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n/* Responsive */\n@media (max-width: 640px) {\n  .confirm-dialog-content {\n    max-width: 100%;\n    margin: 20px;\n    border-radius: 12px;\n  }\n\n  .confirm-dialog-header {\n    padding: 32px 24px 20px;\n  }\n\n  .dialog-icon {\n    padding: 12px;\n  }\n\n  .confirm-dialog-title {\n    font-size: 20px;\n  }\n\n  .confirm-dialog-body {\n    padding: 20px 24px;\n  }\n\n  .confirm-dialog-message {\n    font-size: 14px;\n  }\n\n  .confirm-dialog-footer {\n    padding: 20px 24px;\n    flex-direction: column-reverse;\n  }\n\n  .confirm-dialog-btn {\n    width: 100%;\n    padding: 14px 24px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
